"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledContainer = exports.StyledButton = exports.StyledPopupMenuContainer = exports.StyledContent = void 0;
const styled_components_1 = require("styled-components");
const ui_common_components_1 = require("@desygner/ui-common-components");
const { rem } = ui_common_components_1.utils;
// const sumSizeTopbar = 450;
exports.StyledContent = styled_components_1.default.div `
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: auto;
  padding: ${({ theme }) => `0 ${rem(theme.Spacing.Size.XSmall)}`};
  height: ${rem(20)};

  ${({ theme }) => (0, styled_components_1.css) `
    border-radius: ${rem(theme.Border.Radius.Medium)};
    min-height: ${rem(48)};
    background-color: ${theme.Color.Neutrals.Paper};
    gap: ${rem(theme.Spacing.Size.XXSmall)};
  `}
`;
exports.StyledPopupMenuContainer = styled_components_1.default.div `
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  overflow-x: auto;
  overflow-y: hidden;
  gap: ${({ theme }) => rem(theme.Spacing.Size.XXSmall)};
  scrollbar-width: none;
`;
exports.StyledButton = styled_components_1.default.div `
  display: flex;
  align-items: center;

  button {
    max-width: ${ui_common_components_1.utils.rem(40)};
    height: ${ui_common_components_1.utils.rem(40)};
  }
`;
exports.StyledContainer = styled_components_1.default.div `
  display: flex;
  gap: ${({ theme }) => ui_common_components_1.utils.rem(theme.Spacing.Size.XXSmall)};
`;
//# sourceMappingURL=PopupMenu.styles.js.map